<!-- **** top part of each discussion **** -->
<div class="headerChat" [ngClass]="{'headerChat--fromPdp': chatFromPdp}">
  <!-- 1/ back button & more actions -->
  <div class="headerChat__actions">
    <span (click)="displayListMobile.emit(true)" class="headerChat__actions__return">
      <vc-sprite-icons class="headerChat__actions__return__svg" name="arrow-head-left-thick"></vc-sprite-icons>
    </span>
    <span class="headerChat__actions__receiver">@{{ receiverInfo?.username }}</span>
    <vc-sprite-icons (click)="moreActions()" class="headerChat__actions__more" name="kebab-menu"></vc-sprite-icons>
    <vc-sprite-icons
      (click)="isOpenModal = !isOpenModal"
      class="headerChat__actions__more headerChat__actions__more--desk"
      name="kebab-menu"
    ></vc-sprite-icons>
    <button *ngIf="chatFromPdp" aria-label="close modal" class="headerChat__actions__close" [mat-dialog-close]>
      <span i18n="@@MODAL.BUTTON.CLOSE" class="visuallyhidden">Close</span>
      <vc-sprite-icons name="cross-x"></vc-sprite-icons>
    </button>
    <!-- desktop semi-modal -->
    <div *ngIf="isOpenModal" class="headerChat__actions__modalDesk">
      <ul>
        <li class="headerChat__actions__modalDesk__listed">
          <a
            class="vc-text-s modalDesk__item"
            href="https://faq.vestiairecollective.com/hc/en-us/categories/360001871457-NEW-Buyer-Seller-chat"
            i18n-href="@@CHAT.MODAL.CTA.READ_FAQ_LINK"
            i18n="@@CHAT.MODAL.CTA.READ_FAQ"
          >
            <vc-sprite-icons class="modalDesk__item__svg" name="question-mark"></vc-sprite-icons>
            <span>Read FAQ</span>
          </a>
        </li>
        <li (click)="trackReportClick()" class="headerChat__actions__modalDesk__listed">
          <a
            class="vc-text-s modalDesk__item modalDesk__item--warn"
            [href]="urlFormReport"
            i18n="@@CHAT.MODAL.CTA.REPORT"
          >
            <vc-sprite-icons class="modalDesk__item__svg" name="issue"></vc-sprite-icons>
            <span>Report an issue</span>
          </a>
        </li>
      </ul>

      <ul>
        <li class="vc-text-s modalDesk__item modalDesk__item--warn" (click)="blockUserActions()">
          <ng-container *ngIf="!receiverIsBlocked; else unblock">
            <vc-sprite-icons class="modalDesk__item__svg" name="lock"></vc-sprite-icons>
            <span i18n="@@CHAT.HEADER.BLOCK_USER">Block user</span>
          </ng-container>

          <ng-template #unblock>
            <vc-sprite-icons class="modalDesk__item__svg" name="unlock"></vc-sprite-icons>
            <span i18n="@@CHAT.HEADER.UNBLOCK_USER">Unblock user</span>
          </ng-template>
        </li>
      </ul>
    </div>
    <!-- end desktop semi-modal -->
  </div>

  <!-- 2/ product details -->
  <a class="headerChat__product" [routerLink]="product?.path">
    <vc-images
      class="headerChat__product__img"
      [url]="'/produit/' + (product?.pictures)[0]?.path"
      [alt]="(product?.pictures)[0]?.alt"
      [width]="'48px'"
      [height]="'48px'"
    ></vc-images>
    <div class="headerChat__product__desc">
      <p class="headerChat__product__desc__brand vc-text-m">
        {{ product?.brand.name }}
      </p>
      <p class="headerChat__product__desc__condition vc-text-m">{{ product?.condition.description }}</p>
      <p class="headerChat__product__desc__price vc-text-m">
        <!-- when product has a price drop -->
        <ng-container *ngIf="product?.regularPrice?.formatted; else originalPrice">
          <span class="headerChat__product__desc__price__info headerChat__product__desc__price__info--former">{{
            product?.regularPrice.formatted
          }}</span>

          <ng-container *ngIf="negotiation?.isAccepted && pendingNegotiation; else priceFormatted">
            <span class="headerChat__product__desc__price__info--mmao" i18n="@@CHAT.HEADER.MMAO.ACCEPTED"
              >Offer accepted at {{ negotiation.price.formatted }}</span
            >
          </ng-container>
          <ng-template #priceFormatted>
            <span class="headerChat__product__desc__price__info--update">{{ product?.price.formatted }}</span>
          </ng-template>
        </ng-container>

        <!-- when product still has its initial price -->
        <ng-template #originalPrice>
          <span
            *ngIf="negotiation?.isAccepted && pendingNegotiation; else priceFormattedOriginal"
            class="headerChat__product__desc__price__info--mmao"
            i18n="@@CHAT.HEADER.MMAO.ACCEPTED"
            >Offer accepted at {{ negotiation.price.formatted }}</span
          >
          <ng-template #priceFormattedOriginal>
            <span class="headerChat__product__desc__price__info">{{ product?.price.formatted }}</span>
          </ng-template>
        </ng-template>
      </p>
    </div>
  </a>

  <!-- 3/ mmao actions -->
  <div class="headerChat__mmao">
    <button
      *ngIf="product?.negotiable"
      appOpenMmaoPopin
      [product]="product"
      [negotiation]="negotiation?.isClosed ? null : negotiation"
      [buyerId]="isSeller ? buyerId : ''"
      class=" vc-btn vc-btn--outline vc-btn--small headerChat__mmao__btn headerChat__mmao__offer"
      [ngClass]="{
        'headerChat__mmao__offer--full': isSeller,
        'd-none': hideMmaoCTA
      }"
      [disabled]="disabledMmaoCTA"
    >
      <ng-template #makeAnOffer i18n="@@CHAT.HEADER.CTA.NEGOCIATE">
        Make an offer
      </ng-template>
      <span
        *ngIf="(negotiation?.isAccepted && pendingNegotiation) || pendingNegotiation; else makeAnOffer"
        i18n="@@CHAT.HEADER.CTA.SEE_OFFERS"
      >
        See offers
      </span>
    </button>

    <ng-container *ngIf="!inCart; else viewYourBag">
      <button
        *ngIf="!isSeller"
        class="headerChat__mmao__buy vc-btn vc-btn--primary vc-btn--small"
        [appAddToCart]="negotiation?.isAccepted ? negotiation?.product : product"
        addToCartActive="hasLoader"
        [withPopin]="true"
        [ngClass]="{
          'd-none': hideBuyNowCTA
        }"
        i18n="@@CHAT.HEADER.CTA.BUY_NOW"
      >
        Buy now
      </button>
    </ng-container>
    <ng-template #viewYourBag>
      <vc-ref
        i18n-resource="@@HEADER.LINKS.SEE_MY_CART"
        resource="/shop-cart.shtml"
        class="headerChat__mmao__buy headerChat__mmao__buy--bag vc-btn--full vc-btn--notfull--md-up"
        extraClass="vc-btn vc-btn--primary vc-btn--small"
        i18n="@@CHAT.HEADER.CTA.VIEW_BAG"
        [isFlex]="true"
        >View your bag</vc-ref
      >
    </ng-template>
  </div>
</div>
<p
  *ngIf="isReservedByPremium && !isSeller"
  class="headerChat__product__desc__price__info--reserved vc-text-m"
  i18n="@@CHAT.HEADER.PRODUCT.RESERVED_PREMIUM"
>
  This item is currently reserved by a Premium Member
</p>
